<template>
  <List :mapState="'restaurantProductsCategories'" :allDispatch="'restaurantProductsCategoriesAll'"></List>
</template>
<script>
import List from '@/components/modules/base/list.vue'
export default {
  name: 'Lists',
  components: {
    List
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modules/restaurant/products/categories/list.vue